export const moduleSlug = "PRIMARY_KEY";

export default { moduleSlug };
